import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ezlogzConfig: TSPConfig = {
  key: 'ezlogz',
  name: 'EZLOGZ',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>Get the "External Fleet Key" from your Ezlogz dashboard settings:</p>
      <ol>
        <li>Log into the safety dashboard</li>
        <li>Go to Settings and open the "Fleet Settings" tab</li>
        <li>On that page you will find External Fleet Keys</li>
        <li>If empty, click the "Regenerate" button</li>
      </ol>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'External Fleet Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default ezlogzConfig;
